export const SESSIONS_CONFIG = [
  {
    key: 'breakfast',
    aliases: ['breakfast', 'ontbijt']
  },
  {
    key: 'lunch',
    aliases: ['lunch']
  },
  {
    key: 'dinner',
    aliases: ['dinner', 'diner']
  }
]
